import styled from 'styled-components';

export const TextWrap = styled.span<{ $ellipsis: boolean }>`
  width: 100%;
  min-width: 0;
  overflow: ${({ $ellipsis }) => $ellipsis ? 'hidden' : 'visible'};
  white-space: ${({ $ellipsis }) => $ellipsis ? 'nowrap' : 'normal'};
  text-overflow: ${({ $ellipsis }) => $ellipsis ? 'ellipsis' : 'clip'};
`;
